import { render, staticRenderFns } from "./ManualTransferForm.vue?vue&type=template&id=24727a82&"
import script from "./ManualTransferForm.vue?vue&type=script&lang=js&"
export * from "./ManualTransferForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports